export default __webpack_public_path__ + "static/media/user-plus.d0e3b26f.svg";